import Chance from "chance";
const chance = new Chance();
const adjectives = [
  "tiny",
  "large",
  "soft",
  "fuzzy",
  "adorable",
  "hungry",
  "strong",
  "standing",
  "sitting",
  "fast",
  "slow",
  "wild",
  "tame",
  "determined",
  "encouraging",
  "assured",
  "credible",
  "loving",
  "delightful",
  "intellectual",
  "articulate",
  "delightful",
  "assertive",
  "fair",
  "incredible",
  "clever",
  "daring",
  "remarkable",
  "unparalleled",
  "resplendent",
  "calm",
  "intuitive",
  "contemplative",
  "supportive",
  "astounding",
  "benevolent",
  "effervescent",
  "venturous",
  "deserving",
  "mesmerizing",
  "ingenious",
  "respectful",
  "bold",
  "persistent",
  "congenial",
  "majestic",
  "extraordinary",
  "insightful",
  "approachable",
  "inspiring",
  "humorous",
  "energetic",
  "powerful",
  "handsome",
  "articulate",
  "compassionate",
  "amiable",
  "versatile",
  "diligent",
  "dedicated",
  "proactive",
  "considerate",
  "efficient",
  "quirky",
  "detailed",
  "discreet",
  "optimistic",
  "uncompromising",
  "fearless",
  "courageous",
  "resolute",
  "cautious",
  "dazzling",
  "spunky",
  "direct",
  "exuberant",
  "devoted",
  "inquisitive",
  "strong",
  "methodical",
  "steadfast",
  "elated",
  "alert",
  "patient",
  "tough",
  "motivated",
  "introspective",
  "enthusiastic",
  "opinionated",
  "fascinating",
  "joyous",
  "fabulous",
  "charming",
  "industrious",
  "magnetic",
  "decorous",
  "entertaining",
  "captivating",
  "independent",
  "objective",
  "tenacious",
  "unbiased",
  "rhetorical",
  "reserved",
  "bright",
  "excited",
  "intelligent",
  "comfortable",
  "talkative",
  "unique",
  "observant",
  "talented",
  "sensitive",
  "aware",
  "unconventional",
  "tolerant",
  "willing",
  "knowledgeable",
  "outspoken",
  "adept",
  "logical",
  "confident",
  "endearing",
  "adventurous",
  "sentimental",
  "debonair",
  "persuasive",
  "steady",
  "understanding",
  "enterprising",
  "courteous",
  "analytical",
  "warm",
  "idealistic",
  "eager",
  "honest",
  "proud",
  "brilliant",
  "amusing",
  "caring",
  "productive",
  "curious",
  "engaging",
  "sympathetic",
  "dependable",
  "generous",
  "reflective",
  "modest",
  "gutsy",
  "instinctive",
  "sensible",
  "diplomatic",
  "constructive",
  "committed",
  "responsible",
  "enduring",
  "protective",
  "shrewd",
  "trustworthy",
  "thoughtful",
  "dynamic",
  "honorable",
  "stimulating",
  "secure",
  "receptive",
  "lovable",
  "friendly",
  "cheerful",
  "enchanting",
  "upbeat",
  "frank",
  "wise",
  "electrifying",
  "beautiful",
  "selective",
  "plucky",
  "jovial",
  "sincere",
  "lively",
  "loyal",
  "kind",
  "gentle",
  "passionate",
  "hilarious",
  "patient",
  "breathtaking",
  "amazing",
  "adorable",
  "meticulous",
  "zestful",
  "impartial",
  "forgiving",
  "outgoing",
  "creative",
  "artistic",
  "earnest",
  "happy",
  "alluring",
  "unasssuming",
  "consistent",
  "particular",
  "quick",
  "vigorous",
  "fiery",
  "talented",
  "leader",
  "perceptive",
  "spirited",
  "practical",
  "fantastic",
  "successful",
  "witty",
  "ambitious",
  "brave",
  "helpful",
  "focused",
  "chatty",
  "authentic",
  "succinct",
  "reverent",
  "boundless",
  "fast",
  "calm",
  "unwavering",
  "inventive",
  "entreprenurial",
  "selective",
  "fashionable",
  "balanced",
  "skillful",
  "spontaneous",
  "active",
  "charismatic",
  "incredible",
  "devoted",
  "genuine",
  "candid",
  "attentive",
  "serious",
  "admirable",
  "positive",
  "endless",
  "eloquent",
  "vibrant",
  "communicative",
  "sociable",
  "harmonious",
  "affectionate",
  "interesting",
  "courageous",
  "radical",
  "vivacious",
  "capable",
  "reciprocating",
  "flexible",
  "gracious",
  "original",
  "wonderful",
  "careful",
  "valuable",
  "philosophical",
  "resourceful",
  "coherent",
  "powerful",
  "imaginative",
  "fierce",
  "believable",
  "polite",
  "sensational",
  "jocular",
  "quintessential",
  "terrific",
  "natural",
  "romantic",
  "trustful",
  "young",
  "motivating",
  "adaptable",
  "conscientious",
  "alluring",
  "convivial",
  "decisive",
  "accomplished",
  "gregarious",
  "pioneering",
  "incomparable",
  "poetic",
  "stunning",
  "detailed",
  "fervent",
  "nurturing",
  "distinguished",
  "awesome",
  "mirthful",
  "wondrous",
  "worthy",
  "magical",
  "reliable",
  "gifted",
  "prodigious",
  "animated",
  "phenomenal",
  "intense",
  "compelling",
  "enigmatic",
  "loved"
];

function generateName(charLimit) {
  const randomName = [
    chance.pickone(adjectives),
    chance.word({ length: 5 })
  ].map(word => chance.capitalize(word));

  randomName.push(chance.prime());
  return randomName.join("").substring(0, charLimit);
}

export { generateName };
